import { Link } from 'react-router-dom';

const LINKS = [
  { label: '分类榜单', to: '/category' },
  { label: '连载进度', to: '/progress' },
  { label: '关于我们', to: '/about' },
  { label: '常见问题', to: '/faq' },
];

const GENRES = ['奇幻玄幻', '恋爱浪漫', '热血动作', '悬疑惊悚', '科幻末世', '古风权谋', '日常治愈'];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="mb-4 flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-white">
                <i className="ri-book-open-fill text-lg"></i>
              </span>
              <span className="font-heading text-lg text-primary-700">韩国漫画大全</span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-600">
              每日更新不停歇，连载进度同步，最新上线韩漫新作第一时间收录，本周更新一目了然。做你的韩漫追更第一站。
            </p>
          </div>

          {/* Nav */}
          <div>
            <h4 className="mb-4 text-sm font-semibold text-foreground-900">快捷入口</h4>
            <ul className="space-y-2.5">
              {LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-foreground-600 transition-colors hover:text-primary-600">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Genres */}
          <div>
            <h4 className="mb-4 text-sm font-semibold text-foreground-900">热门分类</h4>
            <div className="flex flex-wrap gap-2">
              {GENRES.map((g) => (
                <Link
                  key={g}
                  to={`/category?genre=${encodeURIComponent(g)}`}
                  className="whitespace-nowrap rounded-full border border-background-200 bg-background-50 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-700"
                >
                  {g}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="mb-4 text-sm font-semibold text-foreground-900">联系我们</h4>
            <ul className="space-y-3 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500"></i>
                <span>contact@kr-manhwa.example.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500"></i>
                <span>每日更新，全年无休</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-refresh-line text-primary-500"></i>
                <span>连载进度实时同步</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© 2026 韩国漫画大全 版权所有 · 每日更新 · 连载进度同步</p>
          <p className="text-xs text-foreground-500">追更韩漫大全最新内容，认准每日更新不停歇</p>
        </div>
      </div>
    </footer>
  );
}